export const colors = {
  black: "#2F2F2F",
  white: "#F7F7F7",
  gray: "#686868",
  grayDisabled: "#838383",
  grayHover: "#565656",
  primary: "#C5EBC3",
  primaryDisabled: "#DAF2D8",
  primaryHover: "#C5EBC3",
  secondary: "#D8D8F6",
  secondaryDisabled: "#E6E6F9",
  secondaryHover: "#C5C5E0",
};

export const fonts = {
  primary: "'Quicksand', sans-serif",
  secondary: "'Montserrat', sans-serif",
};
